import Organisation from '@/models/Organisation';
import { FETCH_ORGANISATIONS } from '@/modules/dashboard/store/actionTypes';
import { IOrganisationState } from '@/modules/organisation/store/state';
import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';
import { OrganisationService } from '../services';
import { OrganisationFormData, OrganisationUser } from '../types';
import * as AT from './actionTypes';
import * as MT from './mutationTypes';
/**
 * --------------------------------------------------
 *  Organisation Actions
 * --------------------------------------------------
 **/
export const OrganisationActions: IOrganisationActions = {
  [AT.FETCH_ORGANISATION]: (
    { commit },
    data: { organisationId: string }
  ): Promise<Organisation> => {
    return OrganisationService.getOrganisation(data).then(
      (organisation: Organisation) => {
        commit(MT.SET_CURRENT_ORGANISATION, organisation);
        return organisation;
      }
    );
  },
  [AT.ADD_ORGANISATION]: (
    { dispatch },
    data: { id: string; data: OrganisationFormData }
  ): Promise<Organisation> => {
    return OrganisationService.addOrganisation(data).then(
      (organisation: Organisation) => {
        dispatch(FETCH_ORGANISATIONS);
        return organisation;
      }
    );
  },
  [AT.EDIT_ORGANISATION]: (
    { dispatch },
    data: { id: string; data: OrganisationFormData }
  ): Promise<Organisation> => {
    return OrganisationService.editOrganisation(data).then(
      (organisation: Organisation) => {
        dispatch(FETCH_ORGANISATIONS);
        return organisation;
      }
    );
  },
  [AT.FETCH_ORGANISATION_USER]: (
    { commit },
    organisationId
  ): Promise<OrganisationUser> => {
    return OrganisationService.getOrganisationUser(organisationId).then(
      (organisationUser: OrganisationUser) => {
        commit(MT.SET_ORGANISATION_USER, organisationUser);
        return organisationUser;
      }
    );
  }
};

/**
 * --------------------------------------------------
 *  Organisation Action Context Interface
 * --------------------------------------------------
 **/
export interface IOrganisationActionContext
  extends ActionContext<IOrganisationState, IRootState> {}

/**
 * --------------------------------------------------
 *  Organisation Actions Interface
 * --------------------------------------------------
 **/
export interface IOrganisationActions
  extends ActionTree<IOrganisationState, IRootState> {
  [AT.FETCH_ORGANISATION](
    context: IOrganisationActionContext,
    data: { organisationId: string }
  ): Promise<Organisation>;
  [AT.ADD_ORGANISATION](
    context: IOrganisationActionContext,
    data: { id: string; data: OrganisationFormData }
  ): Promise<Organisation>;
  [AT.EDIT_ORGANISATION](
    context: IOrganisationActionContext,
    data: { id: string; data: OrganisationFormData }
  ): Promise<Organisation>;
  [AT.FETCH_ORGANISATION_USER](
    context: IOrganisationActionContext,
    organisationId: string
  ): Promise<OrganisationUser>;
}
